<template>
  <div class="step-informacoes">
    <CRow>
      <CCol md="8">
        <div class="form-group">
          <label class="field-label">Descrição</label>
          <input
            class="form-control form-control-sm"
            maxlength="255"
            v-model="item.descricao"
            placeholder="Nome interno do conteúdo"
          />
          <div v-if="validacao.firstError('item.descricao')" class="message">
            {{ validacao.firstError("item.descricao") }}
          </div>
        </div>
      </CCol>
      <CCol md="4">
        <div class="form-group">
          <label class="field-label">Ordem de exibição</label>
          <input
            type="number"
            min="0"
            class="form-control form-control-sm"
            v-model="item.ordem"
          />
          <div v-if="validacao.firstError('item.ordem')" class="message">
            {{ validacao.firstError("item.ordem") }}
          </div>
        </div>
      </CCol>
    </CRow>

    <div class="step-informacoes__section">
      <div class="section-label">Local de exibição</div>
      <div class="step-informacoes__locais-grid">
        <SelectableCard
          v-for="local in locais"
          :key="local.chave"
          :value="local.chave"
          :label="local.label"
          :description="local.description"
          :icon="local.icon"
          :selected="item.chave === local.chave"
          @select="selecionarLocal"
        />
      </div>
      <div v-if="validacao.firstError('item.tipo_id')" class="message">
        {{ validacao.firstError("item.tipo_id") }}
      </div>
    </div>

    <div class="form-group">
      <label class="field-label">Link de destino</label>
      <input
        class="form-control form-control-sm"
        maxlength="1000"
        v-model="item.link"
        placeholder="Ex.: /produtos?categoria=12 ou https://..."
      />
      <p class="step-informacoes__hint">
        Sem link, o conteúdo é apenas exibido, sem ação ao clicar.
      </p>
    </div>

    <BooleanToggle
      label="Conteúdo ativo"
      :value="ativo"
      @input="(valor) => $set(item, 'ativo', valor ? 1 : 0)"
    />
  </div>
</template>

<script>
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import BooleanToggle from "@/views/Campanhas/components/CampanhasComerciais/shared/BooleanToggle.vue";
import { locaisOrdenados } from "../helpers/conteudoLabels";

export default {
  name: "StepInformacoes",
  components: { SelectableCard, BooleanToggle },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
    logosTipo: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    locais() {
      return locaisOrdenados(this.logosTipo);
    },
    ativo() {
      return Number(this.item.ativo) === 1;
    },
  },
  methods: {
    selecionarLocal(chave) {
      const local = this.locais.find((opcao) => opcao.chave === chave);

      this.$set(this.item, "tipo_id", local.id);
      this.$set(this.item, "chave", chave);
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-informacoes__section {
  margin-top: 4px;
  margin-bottom: 14px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-informacoes__locais-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.step-informacoes__hint {
  font-size: 11px;
  color: #98a2b3;
  margin: 3px 0 0;
}

@media (max-width: 768px) {
  .step-informacoes__locais-grid {
    grid-template-columns: 1fr;
  }
}
</style>
